import PropTypes from "prop-types";
import ReactPaginate from "react-paginate";
import classNames from "classnames";
import classes from "./Pagination.module.css";

const Pagination = (props) => {
  const { className, numberOfSlides, slidesPerView, activeIndex, onPageClick } =
    props;

  return (
    <ReactPaginate
      containerClassName={classNames(classes["pagination"], className)}
      nextLabel={null}
      previousLabel={null}
      pageLabelBuilder={() => ""}
      pageClassName={classes["pagination__page"]}
      activeClassName={classes["pagination__page--active"]}
      pageLinkClassName={classes["pagination__page-link"]}
      forcePage={Math.floor(activeIndex / (Number(slidesPerView) || 1))}
      onPageChange={(e) => onPageClick(e.selected)}
      pageRangeDisplayed={10}
      marginPagesDisplayed={2}
      pageCount={
        Array(Math.ceil(numberOfSlides / (Number(slidesPerView) || 1))).length
      }
      renderOnZeroPageCount={null}
      breakLabel="..."
      breakClassName={classes["pagination__break-item"]}
      breakLinkClassName={classes["pagination__break-item-link"]}
    />
  );
};

export default Pagination;

Pagination.propTypes = {
  className: PropTypes.string,
  activeIndex: PropTypes.number,
  numberOfSlides: PropTypes.number,
  slidesPerView: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onPageClick: PropTypes.func,
};
